import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import axiosBaseQueryFactory from "../axiosBaseQuery.factory";
import { IInvoice, IInvoiceStatus } from "../../origin/invoiceApi/types";
import { IDataResponse } from "../../origin/types";
import { IUserAddress } from "../../../components/AddNewAddress/types";
import { RootState } from "../../../store/store";
import { clearAuthData } from "../../../store/slices/auth/authSlice";
import { CLEAR_AUTH_ACTION_TYPE } from "../constants";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_BASE_URL_ADMIN_SERVICE,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth?.accessToken;
    if (typeof token === "string" && token.length > 0) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    headers.set("Content-Type", "application/json");
    return headers;
  },
});

const baseQueryWith401: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);
  if (result.error?.status === 401) {
    api.dispatch({ type: CLEAR_AUTH_ACTION_TYPE }); // also from arg, not store import
  }
  return result;
};

const baseApi = createApi({
  reducerPath: "adminServiceApi",
  baseQuery: baseQueryWith401,
  tagTypes: ["UserCustomFieldLabels", "RequestCustomFieldLabels", "StorageList"],
  endpoints: () => ({}),
});

// `api` is the axios instance. `baseApi` is the RTK Query API, which uses the `api` instance.
export { baseApi };
